import { BrandModel } from "./brandModel"
import { FileModel } from "./fileModel"
import { MarketModel } from "./marketModel"

export class DownloadModel {
  constructor(obj) {
    this.id = obj.strapiId || obj.id
    this.pdf_file = new FileModel(obj.pdf_file)
    this.type = obj.type
    this.description = obj.description || {}
    this.markets = (obj.markets || []).map((market) => new MarketModel(market))
    this.brands = (obj.brands || []).map((brand) => new BrandModel(brand))
    this.availability_regions = obj.availability_regions || []
    this.product_groups = obj.product_groups || []
    this.related_products = obj.related_products || []
    this.application = obj.application
    this.group = "DOWNLOADS-PRODUCT_GROUPS-" + (obj.group || "OTHERS")
  }

  static fromStrapi(obj) {
    return new DownloadModel({
      ...obj,
      pdf_file: FileModel.fromStrapi(obj.pdf_file),
    })
  }

  static fromFile(pdf_file) {
    return new DownloadModel({
      pdf_file,
      id: `file_${pdf_file.id}`,
    })
  }

  hasMarket(marketKey) {
    return (
      !marketKey ||
      this.markets.findIndex((m) => m.name.key === marketKey) !== -1
    )
  }

  hasAvailabilityRegion(availabilityRegionKey) {
    return (
      !availabilityRegionKey ||
      this.availability_regions.findIndex(
        (m) => m.name.key === availabilityRegionKey,
      ) !== -1
    )
  }

  hasProductGroup(productGroupKey) {
    return (
      !productGroupKey ||
      this.product_groups.findIndex((m) => m.value.key === productGroupKey) !==
        -1
    )
  }
}
